var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main page-inside payment-result-page"},[_c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"section hero-section"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v("Thank you for your purchase! In case of any questions, please contact us at "+_vm._s(_vm.$parent.hostname))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }